import {createSettingsParams, SettingsParamType} from '@wix/tpa-settings'

import {booleanMetadata} from '../../../../../utils/builderMetadata'

export type DisplaySettingsParams = {
  showTitle: SettingsParamType.Boolean
  showLocationTabs: SettingsParamType.Boolean
  showExperienceImage: SettingsParamType.Boolean
  showExperienceSummary: SettingsParamType.Boolean
  showExperienceDuration: SettingsParamType.Boolean
  showExperienceDate: SettingsParamType.Boolean
  showExperiencePrice: SettingsParamType.Boolean
}

export const displaySettingsParams = createSettingsParams<DisplaySettingsParams>({
  showTitle: {
    type: SettingsParamType.Boolean,
    getDefaultValue: () => false,
    metadata: booleanMetadata(false, 'Shows or hides the title above the experiences'),
  },
  showLocationTabs: {
    type: SettingsParamType.Boolean,
    getDefaultValue: () => false,
    metadata: booleanMetadata(
      false,
      'Shows or hides the location tabs that filter experiences by location; the tabs appear only when experiences are in more than one location',
    ),
  },
  showExperienceImage: {
    type: SettingsParamType.Boolean,
    getDefaultValue: () => true,
    metadata: booleanMetadata(
      true,
      'Shows or hides the image on each experience card; images appear only when at least one experience has a cover image',
    ),
  },
  showExperienceSummary: {
    type: SettingsParamType.Boolean,
    getDefaultValue: () => true,
    metadata: booleanMetadata(true, 'Shows or hides the short summary on each experience card'),
  },
  showExperienceDuration: {
    type: SettingsParamType.Boolean,
    getDefaultValue: () => true,
    metadata: booleanMetadata(true, 'Shows or hides the duration on each experience card'),
  },
  showExperienceDate: {
    type: SettingsParamType.Boolean,
    getDefaultValue: () => true,
    metadata: booleanMetadata(true, 'Shows or hides the date on each experience card'),
  },
  showExperiencePrice: {
    type: SettingsParamType.Boolean,
    getDefaultValue: () => true,
    metadata: booleanMetadata(true, 'Shows or hides the price on each experience card'),
  },
})
